import type { LucideIcon } from "lucide-react";
import { Badge } from "~/components/ui/badge";
import { Text } from "~/components/text";

interface OverviewTagCardProps {
  contentLanguage: string | undefined;
  icon: LucideIcon;
  title: string;
  tags: string[];
}

export const OverviewTagCard = ({
  contentLanguage,
  icon: Icon,
  title,
  tags,
}: OverviewTagCardProps) => {
  if (tags.length === 0) return null;

  return (
    <div className="rounded-xl border border-secondary-200 p-5">
      <div className="mb-3 flex items-center gap-2">
        <Icon className="size-4 text-secondary-600" />
        <Text variant="label">{title}</Text>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Badge key={tag} variant="secondary" lang={contentLanguage}>
            {tag}
          </Badge>
        ))}
      </div>
    </div>
  );
};
